import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';
import { AllMeetingMessageType } from '../schema/AllMeetingMessageType';
import { EventItemType, MeetingResponseType } from '../schema/EventItemType';
import { OwaDate } from 'owa-datetime';
import { respondToCalendarEventService } from 'mini-calendar-event-services/lib/services/respondToCalendarEventService';
import { respondToMeetingMessageService } from 'mini-calendar-event-services/lib/services/respondToMeetingMessageService';

export interface RespondToMeetingParams {
    item: EventItemType;
    response: MeetingResponseType;
    sendResponse: boolean;
    deleteMeetingMessageCallback?: () => void;
    scope?: EventScope;
    responseMessage?: string;
    proposedStartTime?: OwaDate;
    proposedEndTime?: OwaDate;
    respondToSeries?: boolean;
    shouldDeleteMailItemFromServer?: boolean;
}

export const respondToMeeting = ({
    item,
    response,
    sendResponse,
    deleteMeetingMessageCallback,
    scope: originalScope,
    respondToSeries,
    responseMessage,
    proposedEndTime,
    proposedStartTime,
    shouldDeleteMailItemFromServer,
}: RespondToMeetingParams) => {
    const promiseQueue = [];
    const scope =
        originalScope ?? (respondToSeries ? EventScope.AllInstancesInSeries : EventScope.Default);
    if (item.__type === 'MeetingRequestMessageType:#Exchange') {
        deleteMeetingMessageCallback?.();
        const calendarEvent = item as CalendarEvent;
        promiseQueue.push(
            respondToMeetingMessageService(
                {
                    mailboxInfo: undefined,
                    ...(calendarEvent.AssociatedMailItemId || calendarEvent.ItemId),
                },
                response,
                scope,
                sendResponse,
                responseMessage,
                proposedStartTime,
                proposedEndTime
            )
        );
    } else {
        const calendarItem = item as AllMeetingMessageType;
        promiseQueue.push(
            respondToCalendarEventService(
                {
                    mailboxInfo: undefined,
                    ...(calendarItem.AssociatedCalendarItemId || calendarItem.ItemId),
                },
                response,
                scope,
                sendResponse,
                responseMessage,
                proposedStartTime,
                proposedEndTime,
                shouldDeleteMailItemFromServer
                    ? (item as CalendarEvent).AssociatedMailItemId?.Id
                    : undefined
            )
        );

        // In case of Accept/Tentative all series from an exception, we'll also send respond service call for the exception instance with sendResponse = false
        // The workaround doesn't apply to Decline as server will apply Decline response on exception
        if (
            calendarItem.CalendarItemType === 'Exception' &&
            scope === EventScope.AllInstancesInSeries &&
            (response === 'Accept' || response === 'Tentative')
        ) {
            promiseQueue.push(
                respondToCalendarEventService(
                    {
                        mailboxInfo: undefined,
                        ...(calendarItem.AssociatedCalendarItemId || calendarItem.ItemId),
                    },
                    response,
                    EventScope.ThisInstanceOnly,
                    false,
                    responseMessage,
                    proposedStartTime,
                    proposedEndTime,
                    shouldDeleteMailItemFromServer
                        ? (item as CalendarEvent).AssociatedMailItemId?.Id
                        : undefined
                )
            );
        }
    }
    return Promise.all(promiseQueue);
};
